module.exports = __webpack_public_path__ + "static/cafe-925810de15d5681d2b073e39a7377cd2.jpeg";